<label *ngIf="label" class="ptl-select__label">{{ label }}</label>
<mat-select
  class="sg-select"
  [class.size-s]="size === 's'"
  [value]="value"
  [attr.data-value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [aria-label]="ariaLabel"
  [panelClass]="panelClass"
  (selectionChange)="onSelectionChange($event)"
  (blur)="onBlur()"
>
  @if (selectedOptionFontFamily) {
    <mat-select-trigger [style.font-family]="selectedOptionFontFamily">{{ selectedOptionLabel }}</mat-select-trigger>
  }
  @for (option of options; track option.value) {
    <mat-option [value]="option.value" [attr.data-value]="option.value" [style.font-family]="option.fontFamily">{{
      option.label
    }}</mat-option>
  }
</mat-select>
